const loadItem = (item) => {
  try {
    const serializedItem = sessionStorage.getItem(item);

    if (serializedItem === null) {
      return undefined;
    }

    return JSON.parse(serializedItem);
  } catch (err) {
    return undefined;
  }
};

const saveItem = (state, item) => {
  try {
    const serializedItem = JSON.stringify(state);

    sessionStorage.setItem(item, serializedItem);
  } catch (err) {
    console.error(err);
  }
};

const removeItem = (item) => {
  try {
    sessionStorage.removeItem(item);
  } catch (err) {}
};

const removeAll = () => {
  try {
    sessionStorage.clear();
  } catch (err) {}
};

const hasItem = (item) => {
  try {
    const serializedItem = sessionStorage.getItem(item);
    return !!serializedItem;
  } catch (err) {
    return false;
  }
};

export { loadItem, saveItem, removeItem, hasItem, removeAll };
